export const _whiteboardUrl = state => state.whiteboard.whiteboardUrl
export const _isWhiteboardFullSize = state =>
    state.whiteboard.isWhiteboardFullSize
